<template>
  <div class="content">
    <div class="container-fluid">
      <b-row class="mb-3">
        <b-col class="text-right">
          <b-button squared variant="primary" size="sm" :to="{ path: '/users/create'}">
          Create New
        </b-button>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-12">
          <card>
              <b-row cols="1" cols-md="3" cols-lg="3" class="mb-3">
                <b-col class="my-1">
                  <b-form-group
                    label="Per page"
                    label-for="per-page-select"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-form-select
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col class="my-1">
                  <b-form-group
                    label="Pagination"
                    label-for="pagination"
                    label-size="sm"
                    class="mb-0"
                  >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="categories"
                    align="fill"
                    size="sm"
                    class="my-0"
                    variant="danger"
                  ></b-pagination>
                  </b-form-group>
                </b-col>

                  <b-col class="my-1">
                  <b-form-group
                    label="Filter"
                    label-for="filter-input"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Type to Search"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button variant="warning" :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                </b-row>
          <b-table
          bordered
          striped
          hover
          responsive
          id="user"
          :busy="isBusy"
          :head-variant="headVariant"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
            @filtered="onFiltered"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2 d-flex justify-content-center">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
          </template>
          <template #cell(actions)="row">
            <b-button size="sm" squared variant="outline-primary" class="mr-1" @click="editUser(row.item.actions.id)" v-b-tooltip.hover.topleft="{ variant: 'info' }" title="Edit User">
              <b-icon icon="pencil-fill"></b-icon>
            </b-button>
            <b-button size="sm" squared variant="danger" @click="deleteUser(row.item.actions.id)" v-b-tooltip.hover.topleft="{ variant: 'danger' }" title="Delete User">
              <b-icon icon="trash"></b-icon>
            </b-button>
          </template>
          </b-table>
          </card>
          <div class="row" v-if="this.$dev">
            <div class="col-sm-12">{{ this.items.length }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '@/axios';
import { mapGetters } from "vuex";

  export default {
      components: {
          // Datatable
          // 'my-upload': myUpload
      },
    data () {
      return {
        outletid: '',
        outlet: '',
        isBusy: false,
        headVariant: 'dark',
        fields: [{
          id: 1,
          key: 'sl_no',
          label: 'SL No',
          variant: 'primary'
        }, {
          id: 2,
          key: 'name',
          label: 'Name'
        }, {
          id: 3,
          key: 'email',
          label: 'Email'
        }, {
          id: 4,
          key: 'role',
          label: 'Role'
        }, 
        {
          id: 5,
          key: 'outlet_name',
          label: 'Outlet Name'
        }, {
          id: 6,
          key: 'outlet_code',
          label: 'Outlet Code'
        }, {
          id: 7,
          key: 'actions',
          label: 'Action'
        }],
        items: [],
        // totalRows: '',
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, 25, 50, { value: 100, text: "Show a lot" }],
        filter: null,
        uploadUrl: '',
      }
    },
    computed: {
      ...mapGetters(["user"]),

      totalRows() {
          return this.items.length;
      },
    },
    created() {
      this.user.outlet.forEach((outlet) => {
      if (outlet) {
        console.log('outlet', outlet);
        this.userHasOutlet = true;
        this.outlet = outlet;
        this.outletid = outlet.outletid;
      }
    });
    },
    mounted() {
      this.getUser();
      // this.totalRows = this.items.length
    },
    methods: {
      getUser() {
        this.isBusy = true;
        axios.get('/outlet/user/getAll',{
          outletid: this.outletid
        }).then((res) => {
          this.isBusy = false;
          let items = res.data.data;
          console.log('users',items);
          let obj = [];
          items.forEach((item) => {
            let result = {
              sl_no: item.sl_no,
              name: item.name,
              email: item.email,
              role: item.role !== null && item.role !== undefined ? item.role.display_name : 'N/A',
              outlet_name: item.outlet !== null ? item.outlet.name : 'N/A',
              outlet_code: item.outlet !== null ? item.outlet.outlet_code : 'N/A',
              actions: {
                id: item.id,
              }
            }
            obj.push(result);
          });
          this.items = obj;
          console.log('items', this.items);
        });
      },
      editUser(user) {
        console.log('editUser', user);
            return this.$router.push("/users/edit/" + user);
        },
      deleteUser(user) {
        console.log('deleteUser', user);
        const path = `/outlet/user/delete/${user}`;
        axios.post(path).then((res) => {
          if (res.data.status === 200) {
            this.$notifications.notify({
                      message: res.data.message,
                      icon: 'nc-icon nc-check-2',
                          horizontalAlign: 'right',
                          verticalAlign: 'top',
                          type: 'success'
                  });
            setTimeout(() => {
              this.getUser();
            }, 1000);
          }
        });
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
        this.items.length = filteredItems.length;
        console.log('filteredItems', filteredItems);
        this.isFilter = true;
      },
    },
  }
</script>
<style>
  .img-thumb {
    position: relative;
    width: 90px;
    height: 90px;
    transition: all 0.6s ease-in-out;
    z-index: 0;
  }
  .img-thumb img {
    opacity: 1;
  }
  .img-thumb .img-edit {
    position: absolute;
    top: -7px;
    right: -7px;
    width: 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.4);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    cursor: pointer;
    border-radius: 50%;
    border: 1px solid #ccc;
  }
  .img-thumb:hover > .img-edit, .img-thumb:focus > .img-edit {
    background-color: rgba(0, 0, 0, 0.95);
    transition: all 0.6s ease-in-out;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.8);
  }
  .b-table-busy-slot td {
    width: 100%;
  }
  #user thead tr {
    border-top: 1px solid #dee2e6;
  }
  .table > thead > tr > th {
	white-space: nowrap !important;
}
.input-group-sm > .input-group-append > .btn {
  padding: 0.2rem 0.5rem !important;
}
</style>
